import { PropsWithChildren, SVGProps } from 'react'

export type CustomSVGProps = PropsWithChildren<SVGProps<SVGSVGElement>>

export type CustomSVGWithDirection = CustomSVGProps & {
  direction: 'up' | 'down' | 'left' | 'right'
}

export default function SVG({ children, ...props }: CustomSVGProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      height={'auto'}
      preserveAspectRatio={'xMidYMid meet'}
      {...props}>
      {children}
    </svg>
  )
}
